import RoundChip from "design-system/components/chips/RoundChip";
import React from "react";

function InstalledChip() {
  return <RoundChip label="INSTALLED" />;
}

export default InstalledChip;
